const BETA_MENU_IDS = [
  'managertnbox.monitoring.supply.status',
  'managertnbox.monitoring.print.volume',
]

export function isBetaMenuLink(link) {
  const path = String(link || '').split('?')[0].replace(/\/+$/, '')
  return BETA_MENU_IDS.indexOf(path) >= 0
}
